import { useDispatch } from 'react-redux';
import { logout } from '../../store/authSlice';
import React, { useEffect, useRef, useState } from 'react';
import { Alert, Box, FormControlLabel, Snackbar, Switch, Typography } from '@mui/material';
import { runtime } from '../../platform/runtime';
import { biometrics } from '../../platform/biometrics';

export default function BiometricSettings({ status, onStatusChange }) {
    const dispatch = useDispatch();
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const pending = useRef(false);
    const mounted = useRef(true);
    useEffect(() => {
        mounted.current = true;
        return () => { mounted.current = false; };
    }, []);
    if (!runtime.isNative()) return null;
    const toggle = async () => {
        if (pending.current || !status) return;
        pending.current = true;
        setBusy(true); setError('');
        try {
            if (status.enabled) { await biometrics.disable(); dispatch(logout()); return; }
            await biometrics.enable();
            const current = await biometrics.status();
            if (mounted.current) onStatusChange(current);
        } catch { if (mounted.current) setError('Biometric setup was cancelled or unavailable. You can continue using your password.'); }
        finally { pending.current = false; if (mounted.current) setBusy(false); }
    };
    return <Box sx={{ my: 2 }}>
        <FormControlLabel sx={{ m: 0, width: '100%', justifyContent: 'space-between', minHeight: 48 }}
            labelPlacement="start" label="Use Biometric ID"
            control={<Switch checked={Boolean(status?.enabled)}
                disabled={!status || busy || (!status.available && !status.enabled)}
                onChange={toggle} inputProps={{ role: 'switch', 'aria-describedby': 'biometric-description', 'aria-busy': busy }} />} />
        <Typography id="biometric-description" variant="body2">
            Enable Biometric ID, such as face recognition or fingerprint, to quickly and easily log in
        </Typography>
        <Snackbar open={Boolean(error)} onClose={() => setError('')}>
            <Alert severity="info" onClose={() => setError('')}>{error}</Alert>
        </Snackbar>
    </Box>;
}
